import { useQuery } from '@tanstack/react-query'

import { getTwoFactorNudgePreference } from '@/requests/users'

export function useTwoFactorNudgePreferenceQuery() {
  return useQuery({
    queryKey: ['two-factor-nudge-preference'],
    queryFn: async () => {
      const result = await getTwoFactorNudgePreference()
      if (result.error) throw new Error(result.error.message)
      return result
    },
  })
}
